import obituaryMinimalizm from "./definitions/obituary-minimalizm.json";
import obituaryPogrubione from "./definitions/obituary-pogrubione.json";
import obituaryBlack from "./definitions/obituary-black.json";
import crossPlaque from "./definitions/cross-plaque.json";
import snitchPlaque from "./definitions/snitch-plaque.json";
import coffinPlaque from "./definitions/coffin-plaque.json";
import urnPlaque from "./definitions/urn-plaque.json";
import thankYou from "./definitions/thank-you.json";

import crossMini from "../../../img/crossPlaque1bg.png";
import obituary1Mini from "../../../img/template1.png";
import snitch1Mini from "../../../img/SnitchPlaque1.png";
import coffin1Mini from "../../../img/CoffinPlaque1.png";
import urn1Mini from "../../../img/UrnPlaque1.png";
import black1Mini from "../../../img/blackTemplate1.png";

const layouts = {
  1: {
    name: "Nekrolog",
    params: [
      {
        typeName: "Standardowy",
        layout: obituaryMinimalizm,
        mini: obituary1Mini,
      },
      {
        typeName: "Pogrubione dane",
        layout: obituaryPogrubione,
        mini: obituary1Mini,
      },
    ],
  },
  2: {
    name: "Tabliczka na krzyż",
    params: [{ layout: crossPlaque, mini: crossMini }],
  },
  3: {
    name: "Tabliczka na znicz",
    params: [{ layout: snitchPlaque, mini: snitch1Mini }],
  },
  4: {
    name: "Tabliczka na trumnę",
    params: [{ layout: coffinPlaque, mini: coffin1Mini }],
  },
  5: {
    name: "Tabliczka na urnę",
    params: [{ layout: urnPlaque, mini: urn1Mini }],
  },
  6: {
    name: "Nekrolog czarny",
    params: [{ layout: obituaryBlack, mini: black1Mini }],
  },
  // Podziękowanie po pogrzebie - na ramkach nekrologów (patrz TEMPLATE_TYPE_ALIASES w panelu)
  7: {
    name: "Podziękowanie",
    params: [{ layout: thankYou, mini: obituary1Mini }],
  },
};

// Materiały bez własnych ramek korzystają z ramek innego rodzaju (podziękowanie → ramki nekrologów)
export const TEMPLATE_TYPE_ALIASES = { 7: '1' };
export const templateTypeFor = layoutType => TEMPLATE_TYPE_ALIASES[layoutType] || layoutType;
// Rodzaje ramek do wyboru przy wgrywaniu (bez materiałów korzystających z cudzych ramek)
export const TEMPLATE_TYPE_KEYS = Object.keys(layouts).filter(key => !TEMPLATE_TYPE_ALIASES[key]);

export default layouts;
